/* global google */

import './style.scss';

import React from 'react';
import _ from 'lodash';
import { parseAddress } from '../../models/address';
import './styles.mod.scss';

class Address extends React.Component {
  constructor(props) {
    super(props);
    this.inputEle = props.inputId || 'address-input';
    this.handleSubmit = this.handleSubmit.bind(this);
    this.parseAddress = parseAddress;
    this.inputRef = this.inputRef.bind(this);
  }

  componentDidMount() {
    this.autocomplete = new google.maps.places.Autocomplete(
      document.getElementById(this.inputEle),
      {
        types: ['geocode']
      }
    );
    this.autocomplete.addListener(
      'place_changed',
      this.fillInAddress.bind(this)
    );
    this.geolocate();
    this.geocoder = new google.maps.Geocoder();
  }

  handleSubmit(e) {
    e.preventDefault();
    const address = this.input.value;
    if (!address) return;
    const handleGeoResponse = res => {
      if (!res || !res.length) return;
      const parsed = parseAddress(res[0]);
      this.props.setAddress(parsed, this.props.trackingParams).then(() => {
        if (this.props.scrollOnSubmit) window.scrollTo(0, 0);
      });
    };
    this.geocoder.geocode({ address }, handleGeoResponse);
  }

  inputRef(input) {
    this.input = input;
  }

  fillInAddress() {
    const { setAddress, trackingParams } = this.props;
    const address = parseAddress(this.autocomplete.getPlace());
    setAddress(address, trackingParams);
  }
  geolocate() {
    var self = this;
    const { setAddress } = this.props;
    let trackingParams = this.props.trackingParams;
    trackingParams.source = 'geolocate';
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        var geolocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        var circle = new google.maps.Circle({
          center: geolocation,
          radius: position.coords.accuracy
        });
        self.autocomplete.setBounds(circle.getBounds());

        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({ location: geolocation }, (result, status) => {
          if (!_.isEmpty(self.props.address)) return;
          if (status === 'OK') {
            let parsedAddress = self.parseAddress(result[0]);
            setAddress(parsedAddress, trackingParams);
          } else {
            setAddress(geolocation, trackingParams);
          }
        });
      });
    }
  }

  render() {
    return (
      <div id="address-container">
        <div id="address-box">
          <div>
            <h5>Enter your address to shop available items in your area.</h5>
          </div>
          <i className="fa fa-location-arrow"> </i>
          <span>Unable to confirm your location</span>
          <div id="locationField" className="row address-form">
            <div className="col-xs">
              <div className="input-group">
                <input
                  type="text"
                  id="address-input"
                  className="form-control field-btn"
                  placeholder="Enter your delivery address"
                />
                <span className="input-group-btn">
                  <button className="input-btn" type="button">
                    Go
                  </button>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Address;
